<template>
  <section class="header-container">
    <header class="header">
      <div class="header-left">
        <!-- LOGO -->
        <YorkbbsImage
          class="header-logo"
          :src="require('@/assets/images/common/logo_image.png')"
          :link="'/' | hostBuild('www')"
          target="_blank"
        ></YorkbbsImage>

        <!-- 面包屑 -->
        <YorkbbsBreadcrumb class="header-breadcrumb">
          <slot></slot>
        </YorkbbsBreadcrumb>
      </div>
      <div class="header-right">
        <template v-if="$store.getters.isLogin">
          <YorkbbsImage
            class="header-avatar"
            width="36px"
            height="36px"
            borderRadius="50%"
            :src="user.avatar"
            :link="'/' | hostBuild('home')"
            v-if="user.avatar"
          ></YorkbbsImage>
          <a class="header-user" target="_blank" :href="'/' | hostBuild('home')">{{ user.username }}</a>
          <button class="header-button__logout" @click="onLogout">退出</button>
        </template>
      </div>
    </header>
  </section>
</template>
<script>
import { logoutMixin } from '@/utils/logout.mixin';
import YorkbbsBreadcrumb from '@/common/breadcrumb.vue';
export default {
  name: 'Header',
  // 退出登录后跳转的地址
  props: { logoutURL: String },
  components: { YorkbbsBreadcrumb },
  mixins: [logoutMixin],
  computed: {
    user() {
      return this.$store.getters.user || {};
    },
  },
  methods: {
    /**
     * 退出登录
     */
    onLogout() {
      this.logout(this.logoutURL || '/');
    },
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  background-color: #fafafa;
  border-bottom: 1px solid #efefef;
}
.header {
  width: 1170px;
  height: 64px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  display: flex;
  align-items: center;
}
.header-logo {
  width: 112px;
  margin-right: 16px;
}
.header-breadcrumb {
  padding: 0;
}

.header-right {
  display: flex;
  align-items: center;
}
.header-user {
  font-size: 16px;
  line-height: 20px;
  margin-right: 20px;
  &:hover {
    color: var(--primary-color);
  }
}
.header-button__logout {
  font-size: 14px;
  line-height: 20px;
  color: #999;
}
.header-avatar {
  margin-right: 10px;
}
</style>
